import { useState } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useTopicPageData } from 'src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	description: string | null;
	name: string;
	hasTopicPhoto: boolean;
	trackSAP: () => void;
	onAccordionToggle: (expanded: boolean) => void;
	isExpanded: boolean;
}>;

export function usePageHeading(): Result {
	const {
		data: { description, name, photos },
	} = useTopicPageData();

	const track = useTracking();
	const photo = photos.length ? photos[0] : undefined;
	const hasTopicPhoto = !!(photo?.heroMedium.url && photo.metadata?.credit && photo.metadata.source);
	const [isExpanded, setIsExpanded] = useState(false);

	const handleAccordionToggle = (expanded: boolean) => {
		if (expanded) {
			void track('topic_learn_more_expand');
		}
		setIsExpanded(expanded);
	};

	return {
		data: {
			description,
			name,
			hasTopicPhoto,
			trackSAP: () => {
				void track('topic_sap_click_top');
			},
			onAccordionToggle: handleAccordionToggle,
			isExpanded,
		},
	};
}
